import { ColumnConfig } from "components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const LAUNCHPAD_TRACK_STORAGE_KEY = "launchPadTrackTable";
export const LAUNCHPAD_TRACK_FILTERS_ORDER_SETTINGS_KEY = "launchPadTrackFilters";

export enum LAUNCHPAD_TRACK_COLUMN_ID {
  USERNAME = "USERNAME",
  CERTIFICATES = "CERTIFICATES",
  MISSIONS_PROGRESS = "MISSIONS_PROGRESS",
}

export const ROW_HEADER_ID = LAUNCHPAD_TRACK_COLUMN_ID.USERNAME;

export const initialSortOption = "percentage";
export const initialSortDirection = SearchQueryOrderDirection.Desc;

const MAX_CELL_WIDTH = 600;

export const LAUNCHPAD_TRACK_COLUMN_CONFIG: ColumnConfig = {
  [LAUNCHPAD_TRACK_COLUMN_ID.USERNAME]: {
    title: "Username",
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    static: true,
    allowsSorting: true,
  },
  [LAUNCHPAD_TRACK_COLUMN_ID.CERTIFICATES]: {
    title: "Certificates",
    minWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    static: true,
  },
  [LAUNCHPAD_TRACK_COLUMN_ID.MISSIONS_PROGRESS]: {
    title: "Missions progress",
    minWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    static: true,
    allowsSorting: true,
  },
};

export const SORT_CONFIG: Record<string, string> = {
  [LAUNCHPAD_TRACK_COLUMN_ID.MISSIONS_PROGRESS]: "percentage",
  [LAUNCHPAD_TRACK_COLUMN_ID.USERNAME]: "userLogin",
};

export const INITIAL_COLUMNS_VIEW_CONFIG = {
  visible: Object.keys(LAUNCHPAD_TRACK_COLUMN_CONFIG) as LAUNCHPAD_TRACK_COLUMN_ID[],
  hidden: [],
};
